import React from 'react';
import { observer } from "mobx-react";
import { ShowableProductCard } from "ReactApp/Ddd/Aggregates/ShowableProductCard";
import { H1V1 } from 'ReactApp/Components/H1V1/H1V1';

type ProductHeaderV1Props = {
    productCard: ShowableProductCard
}

const ProductHeaderV1 = observer(({productCard}: ProductHeaderV1Props) => {

    const { realModifiers } = productCard;

    let title = productCard.baseTitle;
    for (let modifier of realModifiers) {
        if (modifier.isActive && productCard.isManuallySetModifier === true) {
            title = productCard.title;
            break;
        }
    }

    return (
        <H1V1 title={title}/>
    )
})

export { ProductHeaderV1 }
